import { useRef } from "react";
import { useContext } from "react";
import classes from "./Account.module.css";
import { CartContext } from "../../../CartContext";
import Header from "../../Header&Footer/Header";
import { Link, useNavigate } from "react-router-dom";

const PasswordReset = (props) => {
  const navigate = useNavigate();
  const authCtx = useContext(CartContext);
  const newPasswordRef = useRef();

  const passwordResetHandler = (e) => {
    e.preventDefault();
    props.isLoading(true);
    const enteredNewPassword = newPasswordRef.current.value;
    fetch(
      "https://identitytoolkit.googleapis.com/v1/accounts:update?key=AIzaSyCilTl0dDYnSgzy29JLmkLF857SH-WWEx0",
      {
        method: "POST",
        body: JSON.stringify({
          idToken: authCtx.token,
          password: enteredNewPassword,
          returnSecureToken: false,
        }),
        headers: {
          "Content-type": "application/json",
        },
      }
    )
      .then((response) => {
        props.isLoading(false);
        return response.json();
      })
      .then((data) => {
        console.log(data);
      });
    navigate("/login");
  };

  return (
    <>
      <Header />
      <div className={classes.body}>
        <div className={classes.form}>
          <form onSubmit={passwordResetHandler}>
            <div className={classes.detail}>
              <label htmlFor="pin">Enter New Password</label>
              <input ref={newPasswordRef} id="pin" type="password" />
            </div>

            <div className={classes.action}>
              <p>
                Back To Home <Link to="/home">Homepage</Link>
              </p>
              <button>
                {props.loading ? "Loading..." : "Change Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PasswordReset;
